"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ReviewOfferModal = void 0;
var _react = _interopRequireWildcard(require("react"));
var _client = require("@apollo/client");
var _dsWeb = require("@olxbr/ds-web");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _reactRedux = require("react-redux");
var _selectors = require("../../../../selectors");
var _platform = require("../../../../helpers/platform");
var _actions = require("../../../../actions");
var _ButtonsWrapper = require("./ButtonsWrapper");
var _jsxRuntime = require("react/jsx-runtime");
var _templateObject, _templateObject2, _templateObject3;
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}
var ProposalWrapper = function ProposalWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Flex, {
    justifyContent: "space-between",
    paddingLeft: "--spacing-1",
    paddingRight: "--spacing-1",
    children: children
  });
};
var GreenText = (0, _styledComponents["default"])(_dsWeb.Text.BodyMedium)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  color: var(--color-feedback-success-100);\n"])));
var APPROOVE_OFFER = (0, _client.gql)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  mutation ApproveOffer($offerId: String!) {\n    approveOffer(offerId: $offerId) {\n        success\n    }\n  }\n"])));
var REJECT_OFFER = (0, _client.gql)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  mutation RejectOffer($offerId: String!) {\n    rejectOffer(offerId: $offerId) {\n        success\n    }\n  }\n"])));
var ReviewOfferModal = exports.ReviewOfferModal = function ReviewOfferModal(_ref2) {
  var reviewOfferData = _ref2.reviewOfferData,
    onSuccessfulAction = _ref2.onSuccessfulAction;
  var partner = (0, _reactRedux.useSelector)(function (state) {
    return (0, _selectors.getCurrentPartner)(state);
  });
  var price = reviewOfferData.price,
    offeredPrice = reviewOfferData.offeredPrice,
    serviceFee = reviewOfferData.serviceFee,
    serviceFeeValue = reviewOfferData.serviceFeeValue,
    finalValue = reviewOfferData.finalValue,
    offerId = reviewOfferData.offerId;
  var _useMutation = (0, _client.useMutation)(APPROOVE_OFFER),
    _useMutation2 = _slicedToArray(_useMutation, 1),
    approveOfferMutation = _useMutation2[0];
  var _useMutation3 = (0, _client.useMutation)(REJECT_OFFER),
    _useMutation4 = _slicedToArray(_useMutation3, 1),
    rejectOfferMutation = _useMutation4[0];
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.viewNegotiationOfferReview)());
    return function () {
      dispatch((0, _actions.clickNegotiationOfferReviewClose)());
    };
  }, []);
  var handleApproveOffer = function handleApproveOffer() {
    dispatch((0, _actions.clickNegotiationOfferReviewAccept)());
    approveOfferMutation({
      variables: {
        offerId: offerId
      }
    }).then(function () {
      dispatch((0, _actions.clickNegotiationOfferReviewAcceptSuccess)());
      onSuccessfulAction('Oferta aceita com sucesso!');
    });
    dispatch((0, _actions.closeModal)());
  };
  var handleRejectOffer = function handleRejectOffer() {
    dispatch((0, _actions.clickNegotiationOfferReviewReject)());
    rejectOfferMutation({
      variables: {
        offerId: offerId
      }
    }).then(function () {
      dispatch((0, _actions.clickNegotiationOfferReviewRejectSuccess)());
      onSuccessfulAction('Oferta rejeitada com sucesso!');
    });
    dispatch((0, _actions.closeModal)());
  };
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
    flexDirection: "column",
    gap: "--spacing-1",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.TitleMedium, {
      children: "Oferta de pre\xE7o"
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Text.BodyMedium, {
      children: ["Voc\xEA recebeu uma oferta de pre\xE7o de", /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
        children: " ".concat(partner.name, " ")
      }), "neste an\xFAncio."]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
      children: "Ao aceitar, somente este comprador ter\xE1 exclusividade do novo valor."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ProposalWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodyMedium, {
        children: "Valor da oferta"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Text.BodyMedium, {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("s", {
          children: price
        }), ' ', /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: offeredPrice
        })]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(ProposalWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Text.BodySmall, {
        children: "Tarifa de servi\xE7o (".concat(serviceFee, ")")
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Text.BodyMedium, {
        children: ["- ", serviceFeeValue]
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_dsWeb.Flex, {
      justifyContent: "space-between",
      padding: "--spacing-1",
      style: {
        backgroundColor: 'var(--color-feedback-success-80)',
        borderRadius: 'var(--border-radius-xs)'
      },
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(GreenText, {
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)("strong", {
          children: "Voc\xEA vai receber"
        })
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(GreenText, {
        children: finalValue
      })]
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Divider, {}), /*#__PURE__*/(0, _jsxRuntime.jsxs)(_ButtonsWrapper.ButtonsWrapper, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        variant: "link-button",
        onClick: handleRejectOffer,
        fullWidth: _platform.isMsite,
        children: "Recusar"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_dsWeb.Button, {
        variant: "primary",
        onClick: handleApproveOffer,
        fullWidth: _platform.isMsite,
        children: "Aceitar oferta"
      })]
    })]
  });
};